import * as Ably from 'ably'

export function initializeRealtimeSubscription(apiKey, channelName, eventName, requiredKeys, callbacks){
  const { success } = callbacks

  const missingKeys = requiredKeys.filter(i => (i === undefined || i === null))

  if (!missingKeys.length && apiKey && channelName && eventName){
    const client = new Ably.Realtime(apiKey)

    const channel = client.channels.get(channelName)
    channel.subscribe(eventName, ({ data }) => {
      if (success) success(data)
    })

    return client
  }

  return null
}

export default initializeRealtimeSubscription
